import { Card } from 'primereact/card';
import { forwardRef, useImperativeHandle, useRef } from 'react';

const YOUTUBE_VIDEO_ID = 't3QjDNYs8vU';

export type DiagnosticVideoHandle = {
  toggleFullscreen: () => void;
};

export const DiagnosticVideo = forwardRef<DiagnosticVideoHandle>((_props, ref) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useImperativeHandle(ref, () => ({
    toggleFullscreen: () => {
      iframeRef.current?.requestFullscreen();
    },
  }));

  return (
    <Card
      className="tw-w-[99%] !tw-p-0 !tw-shadow-none"
      pt={{ content: { className: '!tw-pt-0 tw-rounded-[1.25rem]' } }}
    >
      <div className="tw-relative tw-w-full tw-pt-[56.25%] tw-overflow-hidden tw-rounded-[1.25rem]">
        <iframe
          ref={iframeRef}
          className="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-border-0"
          src={`https://www.youtube.com/embed/${YOUTUBE_VIDEO_ID}`}
          title="Diagnostic video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    </Card>
  );
});

DiagnosticVideo.displayName = 'DiagnosticVideo';
